import React from 'react';
import { Registration } from '../../../types/models/registration';
import { RegistrationItem } from './registration-item';
interface RegistrationsProps {
  registrations: Array<Registration>;
}

export function Registrations(props: RegistrationsProps) {
  return (
    <>
      {props.registrations.map((r) => (
        <RegistrationItem key={r.username} registration={r} />
      ))}
    </>
  );
}
